
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import { useNavigate } from "react-router-dom";

interface SharePremiumFooterProps {
  onUpgradeToPremium: () => void;
}

const SharePremiumFooter = ({ onUpgradeToPremium }: SharePremiumFooterProps) => {
  const navigate = useNavigate();
  
  const handleUpgradeClick = () => {
    // Navigate to premium page with action state to trigger subscription flow
    navigate('/premium', { state: { action: 'subscribe' } });
    // Also call the original handler if provided
    if (onUpgradeToPremium) {
      onUpgradeToPremium();
    }
  };
  
  return (
    <DialogFooter className="sm:justify-start">
      <Button onClick={handleUpgradeClick}>
        Upgrade to Premium
      </Button>
    </DialogFooter>
  );
};

export default SharePremiumFooter;
